import React from 'react';
import { useDeleteContractTemplateMutation } from '../Service/contractTemplatesApi';
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';
import { ContractTemplatesRoutes } from '../../../Router/path';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import CustomCard from '../../Shared/Components/CustomCard/CustomCard';
import InfoIcon from '@mui/icons-material/Info';
import DataTable from '../../Shared/Components/DataTable/DataTable';
import InfoCard from '../../Shared/Components/InfoCard/InfoCard';
import { useSelection } from '../../Shared/Hooks/useSelection';
import { useGetContractTemplatesQuery } from '../Service/contractTemplatesApi';

const ContractTemplates = () => {
  const { selected: selectedTemplateIds, setSelected, resetSelection } = useSelection<number>();

  const {
    data: contractTemplates,
    isLoading: isTemplatesLoading,
    isError: isTemplatesError,
    error: templatesError,
  } = useGetContractTemplatesQuery();

  const [deleteContractTemplate] = useDeleteContractTemplateMutation();
  const handleCreate = useCreateRedirect(ContractTemplatesRoutes.create);

  const handleDeleteSelected = useDeleteSelectedItems<number>(
    selectedTemplateIds,
    (id) => deleteContractTemplate(id).unwrap(),
    resetSelection
  );

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Nazwa szablonu' },
  ];

  return (
    <>
      <InfoCard
        icon={<InfoIcon fontSize="large" color="primary" />}
        title="Szablony kontraktów"
        subheader="Zarządzaj szablonami kontraktów w systemie"
        infoText="
          Na tej stronie zarządzasz wszystkimi dostępnymi szablonami kontraktów w systemie.
          Możesz przeglądać listę istniejących szablonów wraz z podstawowymi informacjami
          (nazwa szablonu).
        "
        hintText="Skorzystaj z przycisków, aby dodać nowy szablon kontraktu lub usunąć wybrane pozycje."
        onCreate={handleCreate}
        onDeleteSelected={handleDeleteSelected}
      />
      <CustomCard>
        <DataTable
          columns={columns}
          data={contractTemplates || []}
          isLoading={isTemplatesLoading}
          isError={isTemplatesError}
          errorMessage={(templatesError as any)?.data?.message}
          getRowId={(row) => row.id}
          onSelectionChange={setSelected}
          onEdit={(id) =>
            (window.location.href = ContractTemplatesRoutes.update.replace(
              ':contractTemplateId',
              id.toString()
            ))
          }
        />
      </CustomCard>
    </>
  );
};

export default ContractTemplates;
